{
  "UnifiedNavigation": "Navegue na Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Selecionar outra conta de organização",
  "help": "Ajuda",
  "profile": "Perfil",
  "searchButton": "Pesquisar",
  "sidenavMenuCloseTooltip": "Fechar o menu",
  "sidenavMenuOpenTooltip": "Abrir o menu",
  "solutionSwitcher": "Alternar para outra solução",
  "toggleSideNav": "Alternar menu de navegação lateral"
}
